<div class="row BG ">
  <div class="row text-container">
    @if ((comparatorError == '' || comparatorError == null)) {
      <div class="col-md-12 Lorem-Ipsum">
        <p class="text-style-1">{{title}}</p>
        <span [innerHTML]="processedString">
          <!-- {{processedString}} -->
        </span>
      </div>
    }
    @if ((comparatorError != '' && comparatorError != null)) {
      <div class="col-md-12 Lorem-Ipsum">
        <p class="text-style-1">{{title}}</p>
        <div [id]="consentError" class="form-validation-error">
          <i class="icon icon-error" aria-hidden="true"></i>
          <p [id]="controlName +'-error'">
          {{consentMessageError}}</p>
        </div>
      </div>
    }
  </div>
  <div class="row margin-0 button-flex-container">
    @if (!isLngIsBest && displayWOMPanel && msgCode !== 3) {
      <div class="col-md-12">
        <button class="btn btn-primary Agree-take-me-to-An btn-show" type="button"
        (click)="agreeToAnnuity()">{{btnText}}</button>
      </div>
    }
  </div>
  @if (showError) {
    <div [id]="controlName +'-error'" class="form-validation-error">
      <i class="icon icon-error" aria-hidden="true"></i>
      <p [id]="controlName +'-error'">
      {{contentData.errorMessage}}</p>
    </div>
  }
</div>